<template>
  <transition
    @before-enter="el => beforeEnter(el as HTMLElement)"
    @enter="(el, done) => enter(el as HTMLElement, done)"
    @after-enter="el => afterEnter(el as HTMLElement)"
    @before-leave="el => beforeLeave(el as HTMLElement)"
    @leave="(el, done) => leave(el as HTMLElement, done)"
    @after-leave="el => afterLeave(el as HTMLElement)"
  >
    <slot />
  </transition>
</template>

<script setup lang="ts">
  import { nextTick } from 'vue';

  function beforeEnter(el: HTMLElement) {
    el.style.height = '0';
    el.style.overflow = 'hidden';
  }
  function enter(el: HTMLElement, done: () => void) {
    nextTick(() => {
      const scrollHeight = el.scrollHeight;
      el.style.transition = 'height 0.25s cubic-bezier(0.4,0,0.2,1)';
      el.style.height = scrollHeight + 'px';
      el.style.overflow = 'hidden';
      el.addEventListener('transitionend', function handler(e) {
        if (e.propertyName === 'height') {
          el.removeEventListener('transitionend', handler);
          el.style.height = '';
          el.style.transition = '';
          el.style.overflow = '';
          done();
        }
      });
    });
  }
  function afterEnter(el: HTMLElement) {
    el.style.height = '';
    el.style.transition = '';
    el.style.overflow = '';
  }
  function beforeLeave(el: HTMLElement) {
    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
  }
  function leave(el: HTMLElement, done: () => void) {
    nextTick(() => {
      el.style.transition = 'height 0.2s cubic-bezier(0.4,0,0.2,1)';
      el.style.height = '0';
      el.style.overflow = 'hidden';
      el.addEventListener('transitionend', function handler(e) {
        if (e.propertyName === 'height') {
          el.removeEventListener('transitionend', handler);
          el.style.overflow = '';
          done();
        }
      });
    });
  }
  function afterLeave(el: HTMLElement) {
    el.style.height = '';
    el.style.transition = '';
    el.style.overflow = '';
  }
</script>
